var Ntss;
(function (Ntss) {
    "use strict";
    function getDigits(val) {
        const digits = [];
        if (!val)
            return digits;
        for (let i = 0; i < val.length; i++) {
            if (!isNaN(parseInt(val.charAt(i)))) {
                digits.push(val.charAt(i));
            }
        }
        return digits;
    }
    Ntss.getDigits = getDigits;
    /**
     * Formats the given telephone text into the formatted phone number
     * @param tel
     */
    function formatPhone(tel, options = { allowExtensions: false, includeParenthesis: false }) {
        if (!tel)
            return '';
        const value = getDigits(tel);
        if (!value)
            return tel;
        const strValue = value.join('');
        let areaCode;
        let prefix;
        let lineNumber;
        let extension;
        let returnString;
        if (strValue.length === 3) {
            areaCode = strValue.substr(0);
            returnString = options.includeParenthesis ? `(${areaCode})` : `${areaCode}`;
        }
        else if (strValue.length > 3 && strValue.length < 7) {
            areaCode = strValue.substr(0, 3);
            prefix = strValue.substr(3);
            returnString = options.includeParenthesis ? `(${areaCode}) ${prefix}` : `${areaCode}-${prefix}`;
        }
        else if (strValue.length > 6 && strValue.length < 11) {
            areaCode = strValue.substr(0, 3);
            prefix = strValue.substr(3, 3);
            lineNumber = strValue.substr(6, 4);
            returnString = options.includeParenthesis ? `(${areaCode}) ${prefix}-${lineNumber}` : `${areaCode}-${prefix}-${lineNumber}`;
        }
        else if (strValue.length > 10 && !options.allowExtensions) {
            areaCode = strValue.substr(0, 3);
            prefix = strValue.substr(3, 3);
            lineNumber = strValue.substr(6, 4);
            returnString = options.includeParenthesis ? `(${areaCode}) ${prefix}-${lineNumber}` : `${areaCode}-${prefix}-${lineNumber}`;
        }
        else if (strValue.length > 10 && strValue.length < 21) {
            areaCode = strValue.substr(0, 3);
            prefix = strValue.substr(3, 3);
            lineNumber = strValue.substr(6, 4);
            extension = strValue.substr(10);
            returnString = `${areaCode}-${prefix}-${lineNumber} ext ${extension}`;
        }
        else if (strValue.length > 20) {
            areaCode = strValue.substr(0, 3);
            prefix = strValue.substr(3, 3);
            lineNumber = strValue.substr(6, 4);
            extension = strValue.substr(10, 10);
            returnString = `${areaCode}-${prefix}-${lineNumber} ext ${extension}`;
        }
        else {
            returnString = strValue;
        }
        return returnString;
    }
    Ntss.formatPhone = formatPhone;
})(Ntss || (Ntss = {}));
